<div class="d-xl-flex align-items-start justify-content-between">
    <div class="mr-xl-4">
        <div class="bloc-title mb-3">My available balance</div>
        <div class="bg-gray-500 p-3 br-15 mb-4">
            <div class="d-flex align-items-center justify-content-center">
                <img
                    src="./assets/images/wallet-small.svg"
                    alt="Wallet"
                    title="Wallet"
                    class="mr-4"
                />
                <div>
                    <span class="d-block text-white mb-2">Available in wallet</span>
                    <h4 class="d-block text-primary" *ngIf="wallet && wallet.amount != null">
                        USD {{ wallet.amount | number: '1.2-2' }}
                    </h4>
                </div>
            </div>
        </div>
    </div>
    <div class="flex-grow-1">
        <div class="bloc-title mb-3">My wallet transactions</div>
        <div class="bg-gray-200 p-3 br-15">
            <div class="tableHolder table-responsive custom-table">
                <table mat-table [dataSource]="dataSource" class="table">
                    <!-- currency -->
                    <ng-container matColumnDef="currency">
                        <th mat-header-cell *matHeaderCellDef>Currency</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.currency }}
                        </td>
                    </ng-container>

                    <!-- amount: the transaction's own amount, signed (T41076) -->
                    <ng-container matColumnDef="amount">
                        <th mat-header-cell *matHeaderCellDef>Amount</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.amount ? (element.type === 'CR' ? '+' : '-') : '' }}{{ element.amount | number: '1.2-2' }}
                        </td>
                    </ng-container>

                    <!-- transaction_date -->
                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef>Transaction Date</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.createdAt | date: 'medium' }}
                        </td>
                    </ng-container>

                    <!-- type -->
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>Type</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.type === 'CR' ? 'Credit' : 'Debit' }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>
